import { createActions } from 'redux-actions';

import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../lib/reduxActionsUtils';
import paymentsApi from '../../api/paymentsApi';
import { Dispatch } from 'react';
import Auth from '../../api/auth';

export const {
  confirmLinkPending,
  confirmLinkFulfilled,
  confirmLinkRejected,
  getAccountsToLinkPending,
  getAccountsToLinkFulfilled,
  getAccountsToLinkRejected,
  setSelectedAccount,
} = createActions(
  actionTypes.CONFIRM_LINK_PENDING,
  actionTypes.CONFIRM_LINK_FULFILLED,
  actionTypes.CONFIRM_LINK_REJECTED,
  actionTypes.GET_ACCOUNTS_TO_LINK_PENDING,
  actionTypes.GET_ACCOUNTS_TO_LINK_FULFILLED,
  actionTypes.GET_ACCOUNTS_TO_LINK_REJECTED,
  actionTypes.SET_SELECTED_ACCOUNT,
  getActionOptions(ACTION_PREFIX)
);

const getAccountsToLink = () => (dispatch: Dispatch<any>) => {
  dispatch(getAccountsToLinkPending());

  return paymentsApi
    .getAccountsToLink()
    .then((response: any) => {
      return dispatch(getAccountsToLinkFulfilled(response));
    })
    .catch((error: any) => {
      return dispatch(getAccountsToLinkRejected(error));
    });
};

const confirmLink = (intentId: string, buyerAccountId: string) => (dispatch: Dispatch<any>) => {
  dispatch(confirmLinkPending());
  return paymentsApi
    .confirmLink(intentId, buyerAccountId)
    .then((response) => {
      Auth.logout();
      return dispatch(confirmLinkFulfilled(response));
    })
    .catch((error: any) => {
      return dispatch(confirmLinkRejected(error));
    });
};

export default {
  confirmLink,
  getAccountsToLink,
  setSelectedAccount,
};
